<template lang="pug">
  .about
    b-container(fluid)
      b-row
        b-col.mb-3.p-0
          GeneralMenu
      b-row.thirdPart.pb-5
        b-col(cols="3")
        b-col(cols="6")
          h2.text-center About
          div.line
          //p.text-center Vestibulum consectetur, sapien id tincidunt vehicula, erat ante pharetra lorem, vitae commodo purus metus vitae massa. Duis et nisl sapien. Msed erat elementum, mattis elit vitae, maximus diam. Mauris sollicitudin orci elit, faucibus feugiat quam tempus ac. Vestibulum eget tempor nunc. Morbi at me
        b-col(cols="3")
      b-row.p-5
        b-col(cols="3")
          img(src="../../public/images/about/Foto_VA.jpg" height="298" width="300" style="object-fit: cover")
          h3.mt-2 VICENÇ ACUÑA
          a(href="mailto:vicenc.acuna@icra.cat") vicenc.acuna@icra.cat
          b-row.mt-2
            b-col
              a(href="http://www.icra.cat/noticies/vicenc-acuna/300" style="color: black") ICRA
          b-row.mt-2
            //b-col(cols="1")
              a(href="https://es.linkedin.com/in/joana-castellar-440955a0")
                img.imageGrey.pb-4(src="../../public/images/about/linkLogo.svg" )
            //b-col(cols="1")
              a(href="https://orcid.org/0000-0003-2362-4417")
                img.imageGrey.pb-4(src="../../public/images/about/researchID.svg" )
            b-col(cols="1")
              a(href="https://scholar.google.com/citations?user=Zg9v_qUAAAAJ&hl=en")
                img.imageGrey.pb-4(src="../../public/images/about/googleLogo.svg" )
        b-col(cols="3")
          img(src="../../public/images/about/Katharine_Cross_photo.jpg" height="300" width="300" style="object-fit: cover")
          h3.mt-2 KATHARINE CROSS
          a(href="mailto:katharine.cross@water-cities.org") katharine.cross@water-cities.org
          //b-row.mt-2
            b-col(cols="1")
              a(href="https://es.linkedin.com/in/joana-castellar-440955a0")
                img.imageGrey.pb-4(src="../../public/images/about/linkLogo.svg" )
            b-col(cols="1")
              a(href="https://orcid.org/0000-0003-2362-4417")
                img.imageGrey.pb-4(src="../../public/images/about/researchID.svg" )
            b-col(cols="1")
              a(href="https://scholar.google.com/citations?user=gxNijMgAAAAJ&hl=pt-PT")
                img.imageGrey.pb-4(src="../../public/images/about/googleLogo.svg" )
        b-col(cols="3")
          img(src="../../public/images/about/Profilna.jpg" height="300" width="300" style="object-fit: cover")
          h3.mt-2 Darja Istenič
          b-row.mt-2
            b-col
              a(href="https://www.uni-lj.si/" style="color: black") University of Ljubljana
          a(href="mailto:darja.istenic@fgg.uni-lj.si") darja.istenic@fgg.uni-lj.si
          b-row.mt-2
            b-col(cols="1")
              a(href="https://www.linkedin.com/in/darja-istenic-7968b833")
                img.imageGrey.pb-4(src="../../public/images/about/linkLogo.svg" )
            b-col(cols="1")
              a(href="https://orcid.org/0000-0002-4705-3906")
                img.imageGrey.pb-4(src="../../public/images/about/researchID.svg" )
            //b-col(cols="1")
              a(href="https://scholar.google.com/citations?user=gxNijMgAAAAJ&hl=pt-PT")
                img.imageGrey.pb-4(src="../../public/images/about/googleLogo.svg" )
        b-col(cols="3")
          img(src="../../public/images/about/foto_lluisCorominas_choped.jpg" height="300" width="300" style="object-fit: cover")
          h3.mt-2 LLUÍS COROMINAS
          b-row.mt-2
            b-col
              a(href="http://www.icra.cat/noticies/lluis-corominas/323" style="color: black") ICRA
          a(href="mailto:lcorominas@icra.cat") lcorominas@icra.cat
          b-row.mt-2
            b-col(cols="1")
              a(href="https://es.linkedin.com/pub/lluis-corominas/6/108/b9")
                img.imageGrey.pb-4(src="../../public/images/about/linkLogo.svg" )
            b-col(cols="1")
              a(href="https://orcid.org/0000-0002-5050-2389")
                img.imageGrey.pb-4(src="../../public/images/about/researchID.svg" )
            b-col(cols="1")
              a(href="http://scholar.google.es/citations?user=5gkpb8QAAAAJ&hl=ca&oi=ao")
                img.imageGrey.pb-4(src="../../public/images/about/googleLogo.svg" )
        b-col(cols="3")
          img(src="../../public/images/about/joaquim.jpg" height="300" width="300" style="object-fit: cover")
          h3.mt-2 JOAQUIM COMAS
          b-row.mt-2
            b-col
              a(href="http://www.icra.cat/" style="color: black") ICRA
          a(href="mailto:jcomas@icra.cat") jcomas@icra.cat
          b-row.mt-2
            b-col(cols="1")
              a(href="https://www.linkedin.com/in/joaquim-comas-05707324/?originalSubdomain=es")
                img.imageGrey.pb-4(src="../../public/images/about/linkLogo.svg" )
            b-col(cols="1")
              a(href="https://orcid.org/0000-0002-5692-0282")
                img.imageGrey.pb-4(src="../../public/images/about/researchID.svg" )
            //b-col(cols="1")
              a(href="http://scholar.google.es/citations?user=5gkpb8QAAAAJ&hl=ca&oi=ao")
                img.imageGrey.pb-4(src="../../public/images/about/googleLogo.svg" )
        b-col(cols="3")
          img(src="../../public/images/about/joana_castellar.jpg" height="300" width="300" style="object-fit: cover")
          h3.mt-2 JOANA CASTELLAR
          b-row.mt-2
            b-col
              a(href="http://www.icra.cat/" style="color: black") ICRA
          a(href="mailto:jcastellar@icra.cat") jcastellar@icra.cat
          b-row.mt-2
            b-col(cols="1")
              a(href="https://es.linkedin.com/in/joana-castellar-440955a0")
                img.imageGrey.pb-4(src="../../public/images/about/linkLogo.svg" )
            b-col(cols="1")
              a(href="https://orcid.org/0000-0003-2362-4417")
                img.imageGrey.pb-4(src="../../public/images/about/researchID.svg" )
            b-col(cols="1")
              a(href="https://scholar.google.com/citations?user=gxNijMgAAAAJ&hl=pt-PT")
                img.imageGrey.pb-4(src="../../public/images/about/googleLogo.svg" )
        b-col(cols="3")
          img(src="../../public/images/about/foto_JPR.jpg" height="300" width="300" style="object-fit: cover")
          h3.mt-2 JOSEP PUEYO-ROS
          b-row.mt-2
            b-col
              a(href="http://www.icra.cat/" style="color: black") ICRA
          a(href="mailto:jpueyo@icra.cat") jpueyo@icra.cat
          b-row.mt-2
            b-col(cols="1")
              a(href="https://www.linkedin.com/in/josep-pueyo-ros-55310847/")
                img.imageGrey.pb-4(src="../../public/images/about/linkLogo.svg" )
            b-col(cols="1")
              a(href="https://orcid.org/0000-0002-1236-5651")
                img.imageGrey.pb-4(src="../../public/images/about/researchID.svg" )
            b-col(cols="1")
              a(href="https://scholar.google.es/citations?user=zP9DBLMAAAAJ")
                img.imageGrey.pb-4(src="../../public/images/about/googleLogo.svg" )

</template>

<script>

  import GeneralMenu from '@/components/GeneralMenu.vue'

  export default {
    name: "About",
    components:{GeneralMenu},
  }
</script>

<style scoped>

  .imageGrey{
    filter: grayscale(100%);
  }
  .imageGrey:hover{
    filter: grayscale(0%);
  }

  .thirdPart{
    color: white;
    background: linear-gradient(267.47deg, #BDE4F7 -89.5%, #00ACE5 96.26%);
    padding-left: 80px;
    padding-right: 80px;
  }
  .thirdPart h2{
    margin-top: 95px;
    margin-bottom: 35px;
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 43px;
    text-align: center;
  }
  .thirdPart .third-text{
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 26px;
  }

  .thirdPart .line{
    width: 307px;
    border: 1px solid #FFFFFF;
    margin-left: auto;
    margin-bottom: 82px;
    margin-right: auto;
  }

</style>